import React from 'react'
import { withStyles } from '@material-ui/core/styles'
import MuiAccordion from '@material-ui/core/Accordion'
import MuiAccordionSummary from '@material-ui/core/AccordionSummary'
import MuiAccordionDetails from '@material-ui/core/AccordionDetails'
import Typography from '@material-ui/core/Typography'
import ExpandMoreIcon from '@material-ui/icons/ExpandMore'

export const Accordion = withStyles({
  root: {
    // border: '1px solid rgba(0, 0, 0, .125)',
    boxShadow: 'none',
    '&:not(:last-child)': {
      borderBottom: 0
    },
    '&:before': {
      display: 'none'
    },
    '&$expanded': {
      margin: '0'
    }
  },
  expanded: {}
})(MuiAccordion)

export const AccordionSummary = withStyles({
  root: {
    backgroundColor: 'rgba(0, 0, 0, 0)',
    border: '1px solid rgba(0, 0, 0, .125)',
    borderBottom: '1px solid rgba(0, 0, 0, .125)',
    marginBottom: -1,
    minHeight: 45,
    '&$expanded': {
      minHeight: 56,
      borderBottom: '1px dotted #d6d6d6'
    }
  },
  content: {
    alignItems: 'center',
    gap: '8px',
    margin: '8px 0',
    '&$expanded': {
      margin: '12px 0'
    },
    '& > h6': {
      margin: '0'
    }
  },
  expanded: {}
})(MuiAccordionSummary)

export const AccordionDetails = withStyles((theme) => ({
  root: {
    padding: theme.spacing(2),
    border: '1px solid rgba(0, 0, 0, .125)',
    display: 'block'
  }
}))(MuiAccordionDetails)
